import { render, staticRenderFns } from "./VendorSubHireUploadDetails.vue?vue&type=template&id=2dd57d67&scoped=true"
import script from "./VendorSubHireUploadDetails.vue?vue&type=script&lang=js"
export * from "./VendorSubHireUploadDetails.vue?vue&type=script&lang=js"
import style0 from "./VendorSubHireUploadDetails.vue?vue&type=style&index=0&id=2dd57d67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd57d67",
  null
  
)

export default component.exports